import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const QRCodePrintable = ({ uniqueId, size = 300, showDetails = true }) => {
  const [qrCodeDataURL, setQrCodeDataURL] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // إنشاء رابط الاسترداد
        const redemptionUrl = `https://evouchers.app/scan?key=${uniqueId}`;
        
        // إعدادات QR Code محسنة للطباعة والمسح
        const options = {
          width: size,
          margin: 4, // هامش أكبر للوضوح
          color: {
            dark: '#000000',  // أسود نقي
            light: '#FFFFFF'  // أبيض نقي
          },
          errorCorrectionLevel: 'H', // أعلى مستوى تصحيح أخطاء
          type: 'image/png',
          quality: 1.0,
          rendererOpts: {
            quality: 1.0
          }
        };

        // إنشاء QR Code
        const dataURL = await QRCode.toDataURL(redemptionUrl, options);
        setQrCodeDataURL(dataURL);
        setLoading(false);
      } catch (err) {
        console.error('Error generating QR code:', err);
        setError('فشل في إنشاء QR Code');
        setLoading(false);
      }
    };

    if (uniqueId) {
      generateQRCode();
    }
  }, [uniqueId, size]);

  if (loading) {
    return (
      <div className="flex flex-col items-center space-y-4 p-6 bg-white rounded-lg border-2 border-gray-200">
        <div 
          className="border-2 border-gray-300 rounded-lg bg-gray-100 p-8 flex items-center justify-center"
          style={{ width: size + 40, height: size + 40 }}
        >
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">جاري إنشاء QR Code...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center space-y-4 p-6 bg-white rounded-lg border-2 border-red-200">
        <div 
          className="border-2 border-red-300 rounded-lg bg-red-50 p-8 flex items-center justify-center"
          style={{ width: size + 40, height: size + 40 }}
        >
          <p className="text-red-600 text-center">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center space-y-4 p-6 bg-white rounded-lg border-2 border-gray-200 shadow-sm">
      {/* QR Code Container */}
      <div 
        className="border-4 border-gray-400 rounded-xl bg-white p-4 shadow-lg"
        style={{ width: size + 40, height: size + 40 }}
      >
        <img 
          src={qrCodeDataURL} 
          alt={`QR Code for ${uniqueId}`}
          className="w-full h-full object-contain"
          style={{ 
            imageRendering: 'crisp-edges',
            imageRendering: '-webkit-optimize-contrast'
          }}
        />
      </div>
      
      {showDetails && (
        <div className="text-center space-y-3 max-w-md">
          {/* Title */}
          <h3 className="text-lg font-bold text-gray-800">رمز الاسترداد</h3>
          
          {/* Unique ID */}
          <div className="bg-gray-100 rounded-lg p-3">
            <p className="text-sm text-gray-600 font-medium mb-1">المعرف الفريد:</p>
            <p className="text-sm text-gray-800 font-mono break-all">
              {uniqueId}
            </p>
          </div>
          
          {/* Instructions */}
          <div className="bg-blue-50 rounded-lg p-3">
            <p className="text-sm text-blue-800 font-medium mb-1">تعليمات الاستخدام:</p>
            <p className="text-xs text-blue-700">
              قم بمسح الرمز باستخدام كاميرا الهاتف أو تطبيق QR Scanner
            </p>
          </div>
          
          {/* Redemption Link */}
          <div className="bg-green-50 rounded-lg p-3">
            <p className="text-sm text-green-800 font-medium mb-1">رابط الاسترداد:</p>
            <p className="text-xs text-green-700 font-mono break-all">
              https://evouchers.app/scan?key={uniqueId}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default QRCodePrintable;
